export default class Entry {
  public id!: string;
  public name !: string;
  public url !: string;
  public imageURL !: string;
  public position !: number;
  public type !: string;
  public types !: string[];
  public musicSub !: string;
  public description !: string;
  public workInProgress !: boolean;
}